import React, { useState } from "react";
import Image from "../elements/Image";
import Button from "../form/front/Button";
import { classNames } from "../../helpers/classNames";

const SingleJobCard = ({ data, onClick, isSelected }) => {
  const [isSaved, setIsSaved] = useState(false);
  // const [isSelected, setIsSelected] = useState(false);

  const checkboxId = `job-card-${data?.id}`;

  return (
    <div className="relative">
      <input
        type="checkbox"
        id={checkboxId}
        checked={isSelected}
        onChange={() => onClick(data)}
        className="peer hidden"
      />

      <label
        htmlFor={checkboxId}
        className={classNames(
          "flex-shrink flex-grow border rounded-2xl py-6 px-6 flex md:flex-row flex-col items-start gap-7 relative shadow-md transition-all duration-300 cursor-pointer",
          isSelected
            ? "border-palatte5"
            : "border-palatte3 hover:border-palatte",
        )}
      >
        {data?.image && (
          <div className="w-11 aspect-square overflow-hidden flex-shrink-0">
            <Image
              src={data?.image}
              alt={data?.title || "logo"}
              classes="object-contain"
            />
          </div>
        )}

        <div className="flex-shrink flex-grow space-y-2 pr-0 md:pr-32">
          {data?.title && (
            <div className="text-black text-xl capitalize font-bold line-clamp-2">
              {data?.title}
            </div>
          )}
          {data?.subtitle && (
            <div className="text-base text-slate-500 font-semibold">
              {data?.subtitle}
            </div>
          )}
          {data?.description && (
            <div
              className="text-base text-slate-500 space-y-1"
              dangerouslySetInnerHTML={{ __html: data?.description }}
            />
          )}

          <div className="flex items-center space-x-2">
            {data?.jobType && (
              <div className="bg-purple-100 rounded-md h-8 flex items-center">
                <div className="text-palatte text-sm font-bold capitalize px-4">
                  {data?.jobType}
                </div>
              </div>
            )}

            {data?.workMode && (
              <div className="bg-teal-100 rounded-md h-8 flex items-center">
                <div className="text-teal-700 text-sm font-bold capitalize px-4">
                  {data?.workMode}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* <div className="absolute right-6 top-4">
          <Button
            buttonLabel="save job"
            buttonLabelClasses="capitalize text-sm font-semibold group-hover:text-white"
            buttonIcon={
              isSaved ? "fa-solid fa-bookmark" : "fa-regular fa-bookmark"
            }
            buttonIconPosition="right"
            buttonFunction={() => {
              if (!isSelected) {
                setIsSaved((prev) => !prev);
              }
            }}
            buttonClasses={classNames(
              "h-9 border border-palatte4 text-sm group transition-all",
              isSaved
                ? "bg-palatte4 text-white"
                : "bg-white text-palatte4 hover:bg-palatte4 hover:text-white",
            )}
          />
        </div> */}
      </label>
    </div>
  );
};

export default SingleJobCard;
